import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import ViewRateManagement from '../../components/templates/admin/ViewRateManagement';

const StoryViewRateManagementPage = () => {
  return (
    <AdminLayout>
      <ViewRateManagement />
    </AdminLayout>
  );
};

export default StoryViewRateManagementPage;
